import parsePhoneNumber, { AsYouType, isPossiblePhoneNumber } from 'libphonenumber-js/max';

export const parsePhoneOnType = (value: string): string => new AsYouType('US').input(value);
export const isNotPhoneUS = (value: string): boolean => parsePhoneNumber(value) && parsePhoneNumber(value)?.country !== 'US';
export const isPhoneInvalid = (value: string): boolean => !isPossiblePhoneNumber(value, 'US') || value.split('0')[0] === '0';
